import React from 'react';
import classNames from 'classnames';

import css from './IconSort.module.css';

/**
 * Map pin icon.
 *
 * @component
 * @param {Object} props
 * @param {string?} props.className add more style rules in addition to components own css.root
 * @param {string?} props.rootClassName overwrite components own css.root
 * @returns {JSX.Element} SVG icon
 */
const IconSort = props => {
  const { rootClassName, className } = props;
  const classes = classNames(rootClassName || css.root, className);
  return (
    <svg
      className={classes}
      width="22"
      height="22"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_2467_1379)">
        <path
          d="M12 21.0001L6.75 15.7501L7.8075 14.6926L12 18.8776L16.1925 14.6926L17.25 15.7501L12 21.0001Z"
          fill="#13472E"
        />
        <path
          d="M12 3L17.25 8.25L16.1925 9.3075L12 5.1225L7.8075 9.3075L6.75 8.25L12 3Z"
          fill="#13472E"
        />
      </g>
      <defs>
        <clipPath id="clip0_2467_1379">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default IconSort;
